<template>
  <div class="bandProfileBaseWrapper">
    <div class="tw-grid tw-grid-cols-1 tw-gap-6 md:tw-gap-8">
      <div v-if="band.news" class="innerBlock">
        <div class="title">
          {{ $t('band.profile.slug.base00') }}
        </div>
        <div v-linkify="band.news" class="text preWrap" />
      </div>
      <div v-if="band.biography" class="innerBlock">
        <div class="title">
          {{ $t('band.profile.slug.base01') }}
        </div>
        <div v-linkify="band.biography" class="text preWrap" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { vLinkify } from '~/directives/Linkify'

import type Band from '~/types/band'
import type { PropType } from 'vue'

export default defineComponent({
  directives: { linkify: vLinkify },
  props: {
    band: {
      type: Object as PropType<Band>,
      required: true,
    },
  },
})
</script>

<style scoped src="./base.css"></style>
<style scoped src="./base720.css"></style>
